import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Input() acceptedFileTypes: string = '';
  @Input() showUploadProgress: boolean = false;
  @Input() uploadProgress: number = 0;
  @Input() maxFileSize: number = 25 * 1024 * 1024; // 25MB by default
  @Input() selectedFile: any = {};
  @Output() filesUploaded = new EventEmitter<File>();
  @Output() fileSelected = new EventEmitter<File>();
  @Output() fileRemoved = new EventEmitter();

  file: File | null = null;
  dragOver: boolean = false;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    if (this.selectedFile) {
      this.file = this.selectedFile;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedFile'] && changes['selectedFile'].currentValue) {
      const file = changes['selectedFile'].currentValue;
      this.file = file;
      // this.fileSelected.emit(file);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dragOver = false;
    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFile(files[0]);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFile(input.files[0]);
    }
  }

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (file.size > this.maxFileSize) {
      const maxSize = this.maxFileSize / 1024 / 1024;
      return this.toastService.showError(
        `O arquivo ${file.name} excede o limite de tamanho de ${maxSize}MB.`,
      );
    }
    this.file = file;
    return this.fileSelected.emit(file);
  }

  removeFile(file: File) {
    this.file = null;
    this.fileRemoved.emit();
  }
}
